<template>
  <div>
    <v-app id="inspire">
      <div class="fd-auth-bg">
        <v-layout wrap justify-center fill-height style="min-height:100vh">
          <v-flex xs11 sm10 md8 lg7 px-2 align-self-center>
            <v-snackbar v-model="showSnackBar" color="black" right :timeout="timeout">
              <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">
                  <span style="color: white">
                    {{ msg }}
                  </span>
                </v-flex>
                <v-flex text-right>
                  <v-btn small :ripple="false" text @click="showSnackBar = false">
                    <v-icon style="color: white">mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-snackbar>

            <v-layout wrap justify-center align-stretch>
              <!-- LEFT: Branding panel -->
              <v-flex sm6 md6 lg6 hidden-xs-only d-flex>
                <v-card outlined class="pa-4 fd-auth-panel" style="border-radius: 0px; width: 100%; height: 100%;">
                  <v-layout wrap justify-center fill-height pt-16>
                    <v-flex xs12 class="fill-height">
                      <v-layout wrap justify-center align-self-center>
                        <!-- Logo with white frosted card to neutralise beige box -->
                        <v-flex xs8 sm6 md5 class="text-center">
                          <div class="fd-logo-card">
                            <v-img
                              src="../../assets/Images/logowhite.png"
                              contain
                              max-height="80px"
                            ></v-img>
                          </div>
                        </v-flex>

                        <v-flex xs12 class="text-center" pt-5>
                          <span class="fd-auth-brand-title">ECOFRAME</span>
                        </v-flex>
                        <v-flex xs12 class="text-center" pt-3>
                          <span class="fd-auth-brand-sub">Your Gateway to Nature's Canvas</span>
                        </v-flex>
                        <v-flex xs10 class="text-center" pt-6>
                          <span class="fd-auth-brand-desc">
                            Kerala Forest Department
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <!-- RIGHT: OTP form -->
              <v-flex xs12 sm6 md6 lg6 d-flex>
                <v-card outlined class="pa-5 fd-form-card" style="border-radius: 0px; width: 100%; height: 100%;">
                  <v-layout wrap justify-center align-center fill-height>
                    <v-flex>
                      <v-layout wrap justify-center>

                        <v-flex xs12 pt-8 pb-2>
                          <v-layout wrap justify-center>
                            <v-flex xs10 text-start>
                              <span class="fd-form-title">Verify Phone</span>
                            </v-flex>
                            <v-flex xs10 pt-1 pb-4>
                              <span class="fd-form-subtitle">Enter the OTP sent to your phone</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs10 pt-2>
                          <div class="fd-auth-input">
                            <v-text-field
                              color="#15803d"
                              label="OTP"
                              outlined
                              dense
                              style="font-family: Inter, sans-serif"
                              type="number"
                              v-model="otp"
                              class="inputPrice"
                              hide-details
                            ></v-text-field>
                          </div>
                        </v-flex>

                        <v-flex xs10 pt-4>
                          <!-- Timer Display -->
                          <div v-if="timeLeft > 0" class="text-center mainfont" style="font-size: 13px; color: #6b7280; font-weight: 500;">
                            Resend OTP in: <span style="font-weight: 700; color: #15803d;">{{ formattedTime }}</span>
                          </div>

                          <!-- Resend OTP Button -->
                          <v-btn v-else class="no-uppercase mainfont" dark block color="#15803d" @click="resendOtp" style="height:44px; font-size:15px; font-weight:600; letter-spacing:0.5px;">
                            Resend OTP
                          </v-btn>
                        </v-flex>

                        <!-- Submit Button -->
                        <v-flex pt-5 pb-2 xs10>
                          <v-btn class="no-uppercase mainfont" dark block color="#15803d" @click="register" style="height:44px; font-size:15px; font-weight:600; letter-spacing:0.5px;">
                            <span>SUBMIT</span>
                          </v-btn>
                        </v-flex>

                        <v-flex xs10 pt-3 pb-8 text-center>
                          <span style="font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 500; color:#555">
                            Already a user?&nbsp;
                            <span
                              style="font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 700; color: #15803d; cursor: pointer;"
                              @click="$router.push('/login')"
                            >SIGN IN</span>
                          </span>
                        </v-flex>

                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

            </v-layout>

            <!-- Footer -->
            <v-flex xs12 class="text-center" pt-4>
              <span style="font-size: 11px; color: rgba(255,255,255,0.55); font-family: 'Inter', sans-serif;">
                ©{{ new Date().getFullYear() }} Kerala Forest Department — All rights reserved
              </span>
            </v-flex>

          </v-flex>
        </v-layout>
      </div>
    </v-app>
  </div>
</template>
  
<script>
import axios from "axios";
import store from "./../../store";
export default {
    data() {
        return {
            ServerError: false,
            showSnackBar: false,
            timeout: 5000,
            msg: null,
            otp: null,
            id: this.$route.query.userId,
            timeLeft: 120, // 2 minutes in seconds
            timerInterval: null,
        };
    },

    computed: {
        // Format the timer as MM:SS
        formattedTime() {
            const minutes = Math.floor(this.timeLeft / 60).toString().padStart(2, "0");
            const seconds = (this.timeLeft % 60).toString().padStart(2, "0");
            return `${minutes}:${seconds}`;
        },
    },
    created() {
        // Start the countdown timer when the page loads
        this.startTimer();
    },
    methods: {

        startTimer() {
            // Clear any existing interval
            if (this.timerInterval) clearInterval(this.timerInterval);

            // Reset timer
            this.timeLeft = 10;

            // Start countdown
            this.timerInterval = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--;
                } else {
                    clearInterval(this.timerInterval); // Stop timer when it hits zero
                }
            }, 1000);
        },

        resendOtp() {
            axios({
                method: "POST",
                url: "/user/resend-otp",
                headers: {
                    token: localStorage.getItem("token"),
                },
                data: {
                    userId: this.id,
                },
            })
                .then((response) => {
                    if (response.data.status) {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                        this.startTimer(); // Restart the countdown timer
                    } else {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                    }
                })
                .catch((err) => {
                    this.ServerError = true;
                    console.error(err);
                });
        },

        register() {
            axios({
                method: "POST",
                url: "/adduser/verify-otp",
                headers: {
                    token: localStorage.getItem("token"),
                },
                data: {
                    otp: this.otp,
                    userid: this.id,
                },
            })
                .then((response) => {
                    if (response.data.status == true) {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                        setTimeout(() => {
                            this.$router.push({ path: "/login" });
                        }, 3000);
                    } else {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                    }
                })
                .catch((err) => {
                    this.ServerError = true;
                    console.error(err);
                });
        },
        login() {
            axios({
                method: "post",
                url: "/login/",
                data: {
                    username: this.username,
                    password: this.password,
                },
            })
                .then((response) => {
                    if (response.data.status) {
                        store.commit("loginUser", response.data.token);
                        var uType = response.data.uType;
                        var path = response.data.path;
                        localStorage.setItem("uType", uType);
                        localStorage.setItem("path", path);
                        if (uType === 777 || uType === 780) {
                            this.$router.push({ path: "/admin-dashboard" });
                        } else {
                            this.$router.push({ path: "/divisiondashboard" });
                        }
                    } else {
                        this.msg = response.data.msg;
                        this.showSnackBar = true;
                    }
                })
                .catch((err) => {
                    store.commit("appLoading", false);
                    this.ServerError = true;
                    console.log(err);
                });
        },

        beforeDestroy() {
        // Clear the timer when the component is destroyed
        if (this.timerInterval) clearInterval(this.timerInterval);
    },

    },
};
</script>
<style>
/* Logo wrapper — white frosted pill to isolate any image bg artifacts */
.fd-logo-card {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  padding: 16px;
  display: inline-block;
  width: 100%;
  backdrop-filter: blur(4px);
}

/* Branding text */
.fd-auth-brand-title {
  font-size: 26px;
  font-weight: 700;
  color: #ffffff !important;
  font-family: "Inter", sans-serif;
  letter-spacing: 1px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.3);
}

.fd-auth-brand-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82) !important;
  font-weight: 300;
  font-family: "Inter", sans-serif;
}

.fd-auth-brand-desc {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.55) !important;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  line-height: 1.7;
}

/* Form title */
.fd-form-title {
  font-family: "Inter", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #14532d;
}

.fd-form-subtitle {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #6b7280;
}

/* Green-tinted input borders (scoped to auth pages) */
.fd-auth-input .v-text-field--outlined fieldset {
  border-color: #a7f3d0 !important;
  transition: border-color 0.2s ease;
}
.fd-auth-input .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #15803d !important;
  border-width: 2px !important;
}

@media (min-width: 1264px) {
  .responsive-card { height: 420px; }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .responsive-card { height: 400px; }
}
@media (min-width: 600px) and (max-width: 959px) {
  .responsive-card { height: 400px; }
}

.no-spinners {
    appearance: textfield;
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
}

.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>       
  